<template>
  <span class="pill m2" :style="colorStyle">{{ code }}</span>
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  affiliate: Object,
  code: String,
  color: String
})


const colorStyle = computed(() => {
  return {
    backgroundColor: props.affiliate?.color || props.color
  }
})
</script>

